import { render, staticRenderFns } from "./TemplatesTableRow.vue?vue&type=template&id=5b96bfd0"
import script from "./TemplatesTableRow.vue?vue&type=script&lang=js"
export * from "./TemplatesTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports